import DeleteIcon from '@mui/icons-material/Delete'
import { Box, Typography, Link } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useFileUpload } from '~/src/hooks'
import { FileUploadStateProps } from '~/src/types/form'
import InfoIcon from '@mui/icons-material/Info'
import { FileUploadArea } from '~/src/components/molecules/Form/FileUploader/FireUploadArea'

interface IFormProps {
  fileData: FileUploadStateProps
  setUploadFile: (file: FileUploadStateProps) => void
}
/**
 * SpecialOfferForm
 * @constructor
 */
export const SpecialOfferForm: React.VFC<IFormProps> = ({
  setUploadFile,
  fileData,
}): JSX.Element => {
  const { t } = useTranslation()
  const { uploadFile, isFileUpLoading, handleFileChange, handleFileDelete } =
    useFileUpload(fileData)

  useEffect(() => {
    // 更新時のファイルのみ
    if (uploadFile?.url.includes('temp')) {
      setUploadFile(uploadFile)
    }
    // 削除時
    if (!uploadFile) {
      setUploadFile(undefined)
    }
  }, [uploadFile])

  /**
   * handleChange
   * ファイルのアップロード
   * @param e
   */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    handleFileChange(e.target.files[0])
  }
  /**
   * handleClear
   */
  const handleClear = () => {
    handleFileDelete()
  }

  return (
    <Box p={'24px'}>
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontSize: '16px',
            lineHeight: '24px',
            color: '#000000',
            maxWidth: '163px',
            width: '100%',
          }}
        >
          {t('special_offer.list')}
        </Typography>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'} pl={'16px'}>
          {isFileUpLoading && (
            <>
              <IconButton color={'success'}>
                <InfoIcon />
              </IconButton>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: 14,
                }}
              >
                Uploading...
              </Typography>
            </>
          )}
          {uploadFile && !isFileUpLoading && (
            <>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: '#1F4266',
                }}
              >
                <Link href={uploadFile.url}>{uploadFile.filename}</Link>
              </Typography>
              <IconButton aria-label="delete" size="small" onClick={handleClear}>
                <DeleteIcon fontSize="inherit" color={'disabled'} />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
      <Box display={'flex'} flexDirection={'row'} mt={'28px'}>
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontSize: '16px',
            lineHeight: '24px',
            color: '#000000',
            maxWidth: '163px',
            width: '100%',
          }}
        >
          {t('special_offer.file_upload')}
        </Typography>
        <Box ml={2}>
          <FileUploadArea
            accept={'.xlsx, .xls, .pdf'}
            uploadLabelText={t('special_offer.drop_your_files_here_or')}
            uploadButtonText={t('special_offer.upload')}
            isDisabled={!(!uploadFile && !isFileUpLoading)}
            handleFileChange={handleChange}
          />
        </Box>
      </Box>
    </Box>
  )
}
